import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withOffshoreConsumptionsEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
